export function getMembers(state) {
  return state.members;
}

export function getMemberById(state, memberId) {
  return getMembers(state).get(memberId);
}
